/**
 * Shared core of the `technical` and `technicals` Vuex namespaces.
 * NOT a Vuex module — never register this in src/store/index.js.
 *
 * `state` MUST stay a function: each call returns fresh arrays so the two
 * registrations never share an array reference. In-place mutations
 * (SET_TECH_IDS, REMOVE_TECH, SET_CERTIFIED_TECH) would otherwise leak
 * across namespaces.
 */
export function createTechnicalBase() {
    return {
        state: () => ({
            technicians: [],
            techIds: [],
            techCertified: [],
            techMarkers: [],
        }),
        getters: {
            getTecnical(state) {
                return state.technicians
            },
            getTechId(state) {
                return state.techIds
            },
        },
        mutations: {
            SET_TECHNICIANS(state, val) {
                state.technicians = val
            },
            SET_TECH_IDS(state, val) {
                if (val != null && val != undefined) {
                    if (val.selected) {
                        if (state.techIds.indexOf(val.id) == -1) {
                            state.techIds.push(val.id)
                        }
                    } else {
                        let position = state.techIds.findIndex(war => war === val.id)
                        state.techIds.splice(position, 1)
                    }
                }
            },
            REMOVE_TECH(state, item) {
                let idx = state.technicians.findIndex(f => f.usuario == item)
                if (idx != -1) {
                    state.technicians.splice(idx, 1);
                }
            },
            SET_CERTIFIED_TECH(state, item) {
                let idx = state.techCertified.findIndex(f => f == item)
                if (idx != -1) {
                    state.techCertified.splice(idx, 1)
                } else {
                    state.techCertified.push(item)
                }
            },
        },
        actions: {
            changeValueTech({ commit }, value) {
                commit('SET_TECHNICIANS', value)
            },
            changeTechIds({ commit }, value) {
                commit('SET_TECH_IDS', value)
            },
        },
    }
}
